export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text)
  } catch {
    const hiddenInput = document.createElement('textarea')
    hiddenInput.value = text
    hiddenInput.className = 'project-toolbar__clipboard-fallback'
    document.body.appendChild(hiddenInput)
    hiddenInput.select()
    document.execCommand('copy')
    document.body.removeChild(hiddenInput)
  }
}
